import React from 'react';
import { isEmpty } from 'lodash';
import { SearchFilterTypes, SearchFilterViews } from 'js/constants/visibilityFilters';
import { SUPPORT_KEY_API_KEY } from 'js/constants/supportPageKeys';
import { CONTACT_SUPPORT_LINK } from 'js/constants/config';
import APIKeysTable from 'js/components/apiKeys/APIKeysTable';
import NoContentTextView from 'js/components/elements/NoContentTextView';
import { BannerDescription } from 'new/elements/BannerDescription';
import APIKeyOverviewTab from './cards/APIKeyOverviewTab';

const description =
  'Securely authenticate and authorize API access with unique API keys. Safeguard sensitive data and ensure authorized usage within your application.';

const availableFilterTypes = [
  SearchFilterTypes.ID,
  SearchFilterTypes.NAME,
  SearchFilterTypes.DESCRIPTION,
  SearchFilterTypes.API_KEY,
];

class ViewAPIKeys extends React.Component {
  componentDidMount() {
    this.props.setContextualSupport(SUPPORT_KEY_API_KEY);
  }

  componentWillUnmount() {
    this.props.unsetContextualSupport(SUPPORT_KEY_API_KEY);
  }

  render() {
    const { apiKeys, apiKeyId, isLoading, fetchAllApiKeys } = this.props;
    const detailViewTabs = [
      {
        tabName: 'Overview',
        tabElement: <APIKeyOverviewTab />,
      },
    ];

    let noContentView = null;

    if (!isLoading && isEmpty(apiKeys)) {
      if (apiKeyId) {
        noContentView = (
          <NoContentTextView
            title={<div>We are sorry, we could not find this API key.</div>}
            subtitle={
              <div>
                Please reload the page or file a{' '}
                <a style={{ color: '#507fe7' }} href={CONTACT_SUPPORT_LINK}>
                  support ticket
                </a>{' '}
                to request support.
              </div>
            }
          />
        );
      } else {
        noContentView = (
          <NoContentTextView
            title={<div>Looks empty here. You have no API keys, try creating one.</div>}
          />
        );
      }
    }

    return (
      <>
        <BannerDescription title="API Keys" description={description} />
        <APIKeysTable
          view={SearchFilterViews.API_KEYS}
          urlId={apiKeyId}
          isLoading={isLoading}
          data={apiKeys}
          loadData={fetchAllApiKeys}
          detailViewTabs={detailViewTabs}
          availableFilterTypes={availableFilterTypes}
          noContentView={noContentView}
        />
      </>
    );
  }
}

ViewAPIKeys.defaultProps = {
  onlyTableView: false,
};

export default ViewAPIKeys;
